import { ProductConfigurationResponse } from "shared/types/__generated__/graphql"

import { isValidVariantKey } from "entities/products/lib/productUtils"

export function isProductConfigurationValid(
  productConfigurationResponse: ProductConfigurationResponse | null | undefined
) {
  return (
    !!productConfigurationResponse &&
    isValidVariantKey(productConfigurationResponse?.variantKey) &&
    !productConfigurationResponse?.error &&
    !((productConfigurationResponse?.errors?.length ?? 0) > 0)
  )
}
